import { LoadingService } from "./shared/services/loading-overlay/loading-overlay.component";
import { VendorAgreementModal } from './modals/vendor-agreement-modal/vendor-agreement-modal.component';
import { VendorSelectionModal } from './modals/vendor-selection-modal/vendor-selection-modal.component';
import { SearchStorageService } from './shared/services/search-storage.service';
import { VendorDetailModalService } from './modals/vendor-detail-modal/vendor-detail-modal.service';
import { VendorSearchService } from './components/vendor-search/vendor-search.service';
import { VendorAgreementModalService } from './modals/vendor-agreement-modal/vendor-agreement-modal.service';
import { ChangeDetectionService } from './shared/services/change-detection.service';
import { DialogService } from './shared/services/dialog.service';
import { VendorSelectionService } from './modals/vendor-selection-modal/vendor-selection-modal.service';
import { QuoteEditModal } from './modals/quote-edit-modal/quote-edit-modal.component';
import { QuoteModalService } from './modals/quote-create-modal/quote-modal.service';
import { QuoteEditModalService } from './modals/quote-edit-modal/quote-edit-modal.service';
import { DocumentPickerService } from './components/document-picker/document-picker.service';
import { QuoteSearchService } from './components/quote-search/quote-search.service';
import { QuickLinksService } from './shared/services/quick-links.service';
import { InvoiceModalService } from './modals/invoice-modal/invoice-modal.service';
import { AgreementSearchService } from './components/agreement-search/agreement-search.service';
import { InvoiceEditModal } from './modals/invoice-modal/edit/invoice-edit-modal.component';
import { DirectModalLinkService } from './components/direct-modal-link/direct-modal-link.component';
import { InvoiceCreateModal } from './modals/invoice-modal/create/invoice-create-modal.component';
import { InvoiceSearchService } from './components/invoice-search/invoice-search.service';
import { VendorDetailModal } from './modals/vendor-detail-modal/vendor-detail-modal.component';
import { QuoteCreateModal } from './modals/quote-create-modal/quote-create-modal.component';

// Wrappers around opening modals
export const modals = [
  VendorDetailModal,
  VendorSelectionModal,
  VendorAgreementModal,
  QuoteCreateModal,
  QuoteEditModal,
  InvoiceEditModal,
  InvoiceCreateModal,
];

export const componentServices = [
  LoadingService,
  QuickLinksService,
  ChangeDetectionService,
  DialogService,
  SearchStorageService,
  VendorDetailModalService,
  VendorSearchService,
  VendorSelectionService,
  AgreementSearchService,
  VendorAgreementModalService,
  QuoteModalService,
  QuoteEditModalService,
  DocumentPickerService,
  QuoteSearchService,
  InvoiceModalService,
  DirectModalLinkService,
  InvoiceSearchService
];

